// Third Party Library
import { useState, useEffect } from "react";
import { Dropdown, message, Table } from "antd";
import { useSelector, useDispatch } from "react-redux";

// Constants Library
import { TEMPLATE } from "../../../../../../constants";

// Components Library
import { TableList, ButtonLink, DrawerRemark } from "../../../../../../components";
import { ActionItems } from "./actions";
import { ExpandTableItems } from "./expandItem";

// Handler Library
import { tableHDLR, filter } from "../../../../../../handlers";

// Services Library
import { REDUX as REDUX_UTIL } from "../../../../../../services/util";

// Redux Actions
import * as REDUX_ACTION from "../../../../../../services/redux/actions";

const { reduxStoreWrapper } = REDUX_UTIL;
const { PAYROLL_FILE_COL, EXPAND_PAYROLL_FILE_COL } = TEMPLATE.TABLEDATA.PAYROLL;
const { PAYROLL_FILE_ISCLOSED } = TEMPLATE.PAYROLL;

const TableFile = (props) => {
    const {
      source,
      filteredData,
      paginatedData,
      tabKey,
      setFilteredData,
    } = props;

    const dispatch = useDispatch();
  
    const [tabStatus, setTabStatus] = useState({});
    const [isOpenRemark, setIsOpenRemark] = useState(false);
    const [filteredInfo, setFilteredInfo] = useState({});
    const [sortedInfo, setSortedInfo] = useState({});
    const [data, setData] = useState({});
    const [messageApi, contextHolder] = message.useMessage();
  
    const user = useSelector(reduxStoreWrapper("user"));
    const company = useSelector(reduxStoreWrapper("company.byID"));
    const loading = useSelector(reduxStoreWrapper("style.loading.payroll"));
  
    const [originalData, setOriginalData] = useState([]);
    const [expandedData, setExpandedData] = useState([]);
    const [isData, setIsData] = useState(false);
    const [selectedRow, setSelectedRow] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [isPending, setIsPending] = useState(false);
    const [isClicked, setIsClicked] = useState(false);
  
    useEffect(() => {
      if (originalData?.length === 0 && !isData && filteredData[tabKey]?.length) {
        setOriginalData(filteredData[tabKey]);
        setIsData(true)
      }
    }, [filteredData, isData, tabKey]);
  
    const filterData = (data) =>
      filter.filterHDLR.tableData(
        data,
        filteredInfo,
        sortedInfo,
      );
  
    useEffect(() => {
      const filteredAndSortedData = filterData(source);
  
      if (tabStatus[tabKey] && filteredAndSortedData.length !== 0) {
        setFilteredData(filteredAndSortedData);
      }
    }, [tabKey, tabStatus[tabKey], sortedInfo, filteredInfo]);
  
    const handleTableChange = (pagination, filters, sorter) => {
      setFilteredInfo(filters);
      setSortedInfo(sorter);
      setTabStatus((prev) => ({
        ...prev,
        [tabKey]: true,
      }));
    };
  
    const handleSearch = (_, confirm) => {
      confirm();
    };

    const markAsClosed = (record) => {
      const prids = record.payrolls.map((p) => p.prid);
      messageApi.open({
        type: "loading",
        content: "Marking as closed...",
        duration: 0,
      });

      dispatch(
        REDUX_ACTION.v1_payroll.payroll_file_close(
          { prids: prids, updatedBy: user.memid },
          () => {
            messageApi.destroy();
          }
        )
      );
    }
  
    const columns = [
      ...PAYROLL_FILE_COL({
        redux: {
          user,
          company
        },
        func: {
          handleSearch,
          DrawerRemark: (data) => {
            setIsOpenRemark(true);
            setData(data);
          },
        },
      }),
      {
        title: "Actions",
        width: 100,
        fixed: "right",
        render: (_, record) => {
          return (
            <Dropdown
              menu={{
                items: ActionItems(
                  record,
                  setData,
                  setIsOpenRemark,
                  user,
                  dispatch,
                  messageApi,
                  markAsClosed
                ),
              }}
            >
              <ButtonLink>Actions</ButtonLink>
            </Dropdown>
          );
        },
      },
    ];
  
    const onSelectRow = (record, selected) => {
      tableHDLR.selectRow(
        setSelectedRowKeys,
        setSelectedRow,
        selectedRow,
        selectedRowKeys,
        record,
        selected
      );
    };
  
    const onSelectAllRows = (selected, selectedRows, changeRows) => {
      tableHDLR.selectAllRows(
        setSelectedRowKeys,
        setSelectedRow,
        selectedRow,
        selectedRowKeys,
        changeRows,
        selected,
      );
    };

    useEffect(() => {
      if (isPending && expandedData && !isClicked){
        const selectChange = expandedData.filter(f => expandedData.map(f => f.prid).includes(f.prid))
        setSelectedRowKeys(expandedData.map(f => f.prid))
        setSelectedRow(selectChange);
      } else if(!isPending) {
        setSelectedRowKeys(selectedRowKeys)
      } 
      if(isClicked && selectedRowKeys.length){
        setIsPending(false)
        setIsClicked(false)
        setSelectedRow([])
        setSelectedRowKeys([])
      } 
    }, [expandedData, selectedRowKeys]);
    
    const rowSelection = {
      selectedRowKeys,
      onSelect: onSelectRow,
      onSelectAll: onSelectAllRows,
    };

    // const columns2 = EXPAND_PAYROLL_FILE_COL({ func: { handleSearch } });
    const columns2 = EXPAND_PAYROLL_FILE_COL({ });

    const expandedRowRender = (record) => {
      const expandPayrollData = record.payrolls;
      setExpandedData(expandPayrollData);

      return ExpandTableItems(
        columns2, 
        expandPayrollData,
        rowSelection
      );
    };
  
    return (
      <>
        {contextHolder}
        <DrawerRemark
          isOpen={isOpenRemark}
          setIsOpen={setIsOpenRemark}
          refid={data.attachment_name}
          statusData={PAYROLL_FILE_ISCLOSED}
          memid={data?.attachment_name}
        />
        <TableList.DataList
          paginatedData={paginatedData}
          columnData={columns}
          onChange={handleTableChange}
          loading={loading}
          expandedRowRender={expandedRowRender}
          user = {user}
          messageApi = {messageApi}
        />
      </>
    );
};
  
export default TableFile;